// ── CallRegister 상수 ────────────────────────────────────────────────────────

/** 한국 표준시(UTC+9) 오프셋 (밀리초) */
export const KST_OFFSET_MS = 9 * 60 * 60 * 1000;

/** 컬럼 최소 너비 (px) */
export const MIN_COL_PX = 64;

/** 컬럼 최소 가중치 (flex-grow 단위) */
export const MIN_COL_WEIGHT = 0.2;

/** 방문일자 컬럼 최소 너비: date 입력 UI가 표시되는 최소 공간 (px) */
export const VISIT_DATE_MIN_PX = 110;

/** 전화번호 입력 최대 길이: 0000-0000-0000 = 14자 */
export const PHONE_INPUT_MAX_LEN = 14;

/** 주소 지오코딩 실패 시 사용자에게 노출할 안내 메시지 */
export const ADDRESS_GEO_FAIL_MESSAGE = '검색되지 않는 주소입니다. 다시한번 확인해 주세요.';

/** Nominatim 결과가 대한민국 범위인지 판단하는 위도 하한 */
export const KOREA_LAT_MIN = 32;
/** Nominatim 결과가 대한민국 범위인지 판단하는 위도 상한 */
export const KOREA_LAT_MAX = 39;
/** Nominatim 결과가 대한민국 범위인지 판단하는 경도 하한 */
export const KOREA_LON_MIN = 123;
/** Nominatim 결과가 대한민국 범위인지 판단하는 경도 상한 */
export const KOREA_LON_MAX = 133;

/** 지역명 접두어 확인용 정규식 */
export const REGION_RE = /^(?:서울|경기|인천|부산|대구|광주|대전|울산|세종|강원|충북|충남|전북|전남|경북|경남|제주)/u;

/** 전화번호 추출 정규식 */
export const PHONE_RE = /(\d{2,4}-\d{3,4}-\d{4})/;

/** 네이버 플레이스 파싱 시 업종으로 혼입되는 UI 텍스트 제거 목록 */
export const INDUSTRY_SKIP_WORDS = [
  '알림받기', '출발', '도착', '저장', '거리뷰', '공유', '전화',
  '음식', '메뉴', '리뷰', '사진', '정보', '영업시간',
  '전화번호', '찾아가기', '전체보기',
  '예약', '문의', '홈', '소식', '요약',
];

/** 신규 등록 폼 기본값 */
export const DEFAULT_FORM = {
  owner_user_id: '',
  visit_date: '',
  visit_time: '',
  phone: '',
  mobile_phone: '',
  ceo_name: '',
  ticket_type_id: null,   // 상품 FK (ticket_types.id)
  ticket_type: '',        // 카테고리명 텍스트 (ticket_type_id=null일 때 사용)
  company_name: '',
  industry: '',
  address: '',
  sales_person_name: '',
  content: '',
  keep_memo: '',
};

// ── 그리드 컬럼 정의 ────────────────────────────────────────────────────────

/** 등록 폼 컬럼 목록 (입력창): key·label·w(가중치)·min_px(최소 px) */
export const FORM_COLUMNS = [
  { key: 'user_name',         label: '담당자',        w: 0.72 },
  { key: 'naver',             label: '네이버플레이스', w: 1.0 },
  { key: 'ticket_type',       label: '상품',          w: 0.62 },
  { key: 'visit_date',        label: '방문일자',       w: 0.8, min_px: VISIT_DATE_MIN_PX },
  { key: 'company_name',      label: '상호',          w: 1.0 },
  { key: 'industry',          label: '업종',          w: 0.65 },
  { key: 'address',           label: '주소',          w: 1.35 },
  { key: 'visit_time',        label: '미팅시간',       w: 0.7 },
  { key: 'phone',             label: '전화번호',       w: 0.95, min_px: 140 },
  { key: 'mobile_phone',      label: '휴대폰',         w: 0.95, min_px: 140 },
  { key: 'ceo_name',          label: '대표자',         w: 0.75 },
  { key: 'content',           label: '내용',          w: 1.35 },
  { key: 'sales_person_name', label: '마케팅담당자',   w: 0.85 },
  { key: 'submit',            label: '등록',          w: 1.25 },
  { key: 'result',            label: '결과',          w: 0.9 },
];

/** 목록 컬럼 목록: key·label·w(가중치)·min_px·db(관리자 툴팁용 DB 경로) */
export const LIST_COLUMNS = [
  { key: 'user_name',         label: '담당자',       w: 0.72,                    db: 'tm_calls.user_id → users.name' },
  { key: 'call_date',         label: '콜일자',       w: 1.0,                     db: 'tm_calls.call_date' },
  { key: 'ticket_type',       label: '상품',         w: 0.62,                    db: 'tm_calls.ticket_type' },
  { key: 'visit_date',        label: '방문일자',     w: 0.8, min_px: VISIT_DATE_MIN_PX, db: 'tm_calls.visit_date' },
  { key: 'company_name',      label: '상호',         w: 1.0,                     db: 'tm_calls.company_name' },
  { key: 'industry',          label: '업종',         w: 0.65,                    db: 'tm_calls.industry' },
  { key: 'address',           label: '주소',         w: 1.35,                    db: 'tm_calls.address' },
  { key: 'visit_time',        label: '미팅시간',     w: 0.7,                     db: 'tm_calls.visit_time' },
  { key: 'phone',             label: '전화번호',     w: 0.95, min_px: 140,       db: 'tm_calls.phone' },
  { key: 'mobile_phone',      label: '휴대폰',       w: 0.95, min_px: 140,       db: 'tm_calls.mobile_phone' },
  { key: 'ceo_name',          label: '대표자',       w: 0.75,                    db: 'tm_calls.ceo_name' },
  { key: 'content',           label: '내용',         w: 1.35,                    db: 'tm_calls.content' },
  { key: 'sales_person_name', label: '마케팅담당자', w: 0.85,                    db: 'tm_calls.sales_person_id → users.name' },
  { key: 'actions',           label: '관리',         w: 1.25 },
  { key: 'result',            label: '결과',         w: 0.9,                     db: 'tm_calls.is_contracted, contract_date' },
];

/** 등록 필수 입력 필드 key 목록 */
export const REQUIRED_FIELDS = [
  'ticket_type_id', 'visit_date', 'company_name', 'industry',
  'address', 'visit_time', 'phone', 'ceo_name', 'content', 'sales_person_name',
];

/** 필수 필드의 사용자 표시 레이블 */
export const REQUIRED_LABELS = {
  ticket_type_id:     '상품',
  visit_date:         '방문일자',
  company_name:       '상호',
  industry:           '업종',
  address:            '주소',
  visit_time:         '미팅시간',
  phone:              '전화번호',
  ceo_name:           '대표자',
  content:            '내용',
  sales_person_name:  '마케팅담당자',
};
